import { Helmet } from 'react-helmet';

import { defaultNext } from '@/auth';
import ResetPasswordFlow from '@/auth/components/CognitoPasswordReset/ResetPasswordFlow';
import { safeNextPath } from '@/auth/utils/mfaGate';
import LayoutPage from '@/components/Layout/LayoutPage';
import { LegacyRoute } from '@/routes/routesMiddleware';

const route: LegacyRoute = {
  path: '/password_reset',

  async action({ query }) {
    // The login page links here with its `next`; only same-origin paths are followed.
    const next = safeNextPath(query.get('next')) ?? defaultNext;

    return (
      <LayoutPage>
        <Helmet>
          <title>Reset Password | OnFrontiers</title>
        </Helmet>
        <ResetPasswordFlow token={query.get('password_token') ?? undefined} next={next} />
      </LayoutPage>
    );
  },
};

export default route;
